<template>
    <div class="resource_subject_add_wrap">
        <div class="header">
            <el-button size="medium" @click="goBack">返回</el-button>
            <el-button size="medium" type="primary" @click="saveHandler">保存</el-button>
        </div>
        <div class="resource_subject_box" :style="`height: ${windowHeight - 170}px;`">
            <div class="resource_subject_content">
                <el-form :model="formData" :rules="rules" ref="form" label-width="140px" class="demo-ruleForm">
                    <el-form-item label="年龄段" prop="gradeLevel">
                        <el-select v-model="formData.gradeLevel" placeholder="请选择年龄段" size="medium">
                            <el-option label="3-4岁" :value="1"></el-option>
                            <el-option label="4-5岁" :value="2"></el-option>
                            <el-option label="5-6岁" :value="3"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="封面" prop="bookPic">
                        <uploader pathPrefix="resourceSubject" :extList="['png', 'jpg', 'jpeg']" showResult="image" showMode="cover" v-model="logoUrl" :multiple="false"></uploader>
                    </el-form-item>
                </el-form>
            </div>
        </div>
    </div>
</template>

<script>
    import windowResize from '@/mixins/windowResize'
    import Uploader from "@/components/Uploader/WebUploader";
    import {
        addChildLearnDevelopGuide,
    } from '@/api/watchingRecords'

    export default {
        name: "resourceSubjectAdd",
        components: {Uploader},
        data() {
            return {
                logoUrl: [],
                formData: {
                    gradeLevel: 1,
                },
                rules: {
                    gradeLevel: [
                        {required: true, trigger: 'blur', message: '请选择年级'}
                    ]
                },
                id: this.$route.query.id,
                isEdit: !!this.$route.query.id
            }
        },
        mixins: [windowResize],
        created() {

        },
        methods: {
            goBack() {
                this.$router.go(-1);
            },
            saveHandler() {
                this.$refs.form.validate(isValid => {
                    if(isValid) {
                        addChildLearnDevelopGuide({
                            gradeLevel: this.formData.gradeLevel,
                            level: 1,
                            logoUrl: this.logoUrl.length !== 0 ? this.logoUrl[0] : '',
                            name: ['', '3-4岁', '4-5岁', '5-6岁'][this.formData.gradeLevel],
                            orderNo: 1,
                            pid: 0,
                            remark: '',
                            type: 1
                        })
                            .then(res => res.data)
                            .then(data => {
                                if(data.result) {
                                    this.$message.success(`新增成功`);
                                    setTimeout(() => {
                                        this.$router.back();
                                    }, 500);
                                } else {
                                    this.$message.error(data.msg);
                                }
                            })
                    }
                })
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import './../../styles/mixin';

    .resource_subject_add_wrap {
        padding: 12px;

        .header {
            padding-bottom: 10px;
            border-bottom: 1px solid #eee;
        }

        .resource_subject_box {
            @include scrollBar;

            .resource_subject_content {
                width: 810px;
                margin: 0 auto;
                padding-top: 20px;

            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/views/watchingRecords/watchingRecordsSettingAddEdit.vue